module.exports = __webpack_public_path__ + "static/media/Solarfarm.cf92771c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Solarfarm.svg
// module id = 200
// module chunks = 0